module.exports = __webpack_public_path__ + "static/media/events-main-home.85ce0b5b.png";